// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callout-skwiz {
    background: #5461D2;
}

.callout-skwiz-gradient {
    background: linear-gradient(to right, black 1px, transparent 1px),
    linear-gradient(to bottom, black 1px, transparent 1px);
    background-size: 32px 32px;
    background-position: center;
}

.callout-skwiz-grid {
    background: linear-gradient(to bottom, rgba(84, 97, 210, 2), rgba(84, 97, 210, 0.8));
    height: 100%;
}

.callout-skwiz-content {
    padding: 120px 0;
    display: grid;
    align-content: center;
    justify-content: center;
    align-items: center;
    justify-items: center;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 96px;
    grid-auto-rows: minmax(100%, auto);
}

.callout-skwiz-content-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 48px;
    flex: 1 0;
}

.callout-skwiz-content-text-container {
    display: flex;
    width: 100%;
    max-width: 476px;
    align-items: flex-start;
    gap: 32px;
    flex-direction: column;
    text-align: initial;
}

.callout-skwiz-content-text p {
    color: #FFF;
    font-family: Montserrat;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

img.callout-skwiz-content-image {
    width: 100%;
    height: auto;
}

@media screen and (max-width: 1000px){
    .callout-skwiz-content {
        display: block;
    }
    .callout-skwiz-content-text {
        margin-bottom: 96px;
    }
}

@media screen and (max-width: 600px) {
    .callout-skwiz-content-text p {
        font-size: 14px;
    }

    .callout-skwiz-content-text-container {
        gap: 24px;
    }

    .callout-skwiz-content-text-container img {
        width: 150px;
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/section-skwiz/section-skwiz.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI;0DACsD;IACtD,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,oFAAoF;IACpF,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,qCAAqC;IACrC,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,SAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ","sourcesContent":[".callout-skwiz {\n    background: #5461D2;\n}\n\n.callout-skwiz-gradient {\n    background: linear-gradient(to right, black 1px, transparent 1px),\n    linear-gradient(to bottom, black 1px, transparent 1px);\n    background-size: 32px 32px;\n    background-position: center;\n}\n\n.callout-skwiz-grid {\n    background: linear-gradient(to bottom, rgba(84, 97, 210, 2), rgba(84, 97, 210, 0.8));\n    height: 100%;\n}\n\n.callout-skwiz-content {\n    padding: 120px 0;\n    display: grid;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 96px;\n    grid-auto-rows: minmax(100%, auto);\n}\n\n.callout-skwiz-content-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    gap: 48px;\n    flex: 1 0 0;\n}\n\n.callout-skwiz-content-text-container {\n    display: flex;\n    width: 100%;\n    max-width: 476px;\n    align-items: flex-start;\n    gap: 32px;\n    flex-direction: column;\n    text-align: initial;\n}\n\n.callout-skwiz-content-text p {\n    color: #FFF;\n    font-family: Montserrat;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\nimg.callout-skwiz-content-image {\n    width: 100%;\n    height: auto;\n}\n\n@media screen and (max-width: 1000px){\n    .callout-skwiz-content {\n        display: block;\n    }\n    .callout-skwiz-content-text {\n        margin-bottom: 96px;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .callout-skwiz-content-text p {\n        font-size: 14px;\n    }\n\n    .callout-skwiz-content-text-container {\n        gap: 24px;\n    }\n\n    .callout-skwiz-content-text-container img {\n        width: 150px;\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
